import { useOrgSelection } from "@/context/use-org-selection";

/**
 * Organization switcher.
 *
 * Selecting an org changes which customer database subsequent requests act on,
 * via the `X-Shadow-Org` header. Hidden until more than one org is available —
 * a single-org configurator has nothing to choose between.
 */
export const OrgPicker = () => {
	const { isLoading, organizations, selected, selectOrg } = useOrgSelection();

	if (isLoading) {
		return (
			<span className="text-tertiary text-sm">Loading organizations…</span>
		);
	}

	if (organizations.length <= 1) {
		return selected ? (
			<span className="text-secondary text-sm">{selected.name}</span>
		) : null;
	}

	return (
		<label className="flex items-center gap-2">
			<span className="sr-only">Organization</span>
			<select
				className="border-secondary bg-primary text-primary rounded-md border px-2 py-1 text-sm"
				onChange={(event) => selectOrg(event.target.value)}
				value={selected?.orgCode ?? ""}
			>
				{organizations.map((org) => (
					<option key={org.orgCode} value={org.orgCode}>
						{org.name}
					</option>
				))}
			</select>
		</label>
	);
};
